import { defineStore } from 'pinia';

// Sidebar open/closed state, shared between Navbar.ce.vue (the toggler
// button) and App.vue (which applies the "open" class to .sidebar/.content).
// Real reactive Vue state instead of the old raw DOM querySelector/
// classList approach in assets/js/main.ts, which raced against Vue's own
// mount/render timing and would intermittently fail to attach at all.
export const useLayoutStore = defineStore('layout', {
    state: () => ({
        sidebarOpen: false,
    }),
    actions: {
        toggleSidebar() {
            this.sidebarOpen = !this.sidebarOpen;
        },
    },
});
